function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.14 20h11.72a1.76 1.76 0 001.757-1.758V5.86h-4.101a1.76 1.76 0 01-1.758-1.757V0H4.14a1.76 1.76 0 00-1.758 1.758v16.484c0 .97.788 1.758 1.758 1.758zM6.485 8.242h7.032a.586.586 0 110 1.172H6.484a.586.586 0 110-1.172zm0 2.344h7.032a.586.586 0 110 1.172H6.484a.586.586 0 110-1.172zm0 2.344h7.032a.586.586 0 110 1.172H6.484a.586.586 0 110-1.172zm0 2.343h4.688a.586.586 0 110 1.172H6.484a.586.586 0 110-1.172z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.516 4.688h3.758L12.93.344v3.758c0 .323.262.586.586.586z",
  fill: "#fff"
});

function SvgDocumentManagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgDocumentManagement;